import { HeaderOptions } from '../Layout/Header/model';
import Partner1Logo from '../../assets/images/partnerLogo1.png';
import Partner2Logo from '../../assets/images/partnerLogo2.png';
import Partner3Logo from '../../assets/images/partnerLogo3.png';

const DEFAULT_STATE: FooterState = {
	getServices: () => {
		return [
			{
				text: 'Verify your products here',
				logoUrl: Partner3Logo,
				href: 'https://marketreadyinsights.com/marketready-verified',
				label: '',
				logoWidth: 'auto',
				logoHeight: '52.5px'
			}
		];
	},
	getPartners: () => {
		return [
			{
				text: 'Start your relationship with us',
				logoUrl: Partner1Logo,
				href: 'https://www.spins.com/',
				label: 'Powered by',
				logoWidth: 'auto',
				logoHeight: '44.6px'
			},
			{
				text: 'Learn about measuring your impact',
				logoUrl: Partner2Logo,
				href: 'https://howgood.com/',
				label: 'Sustainability data by',
				logoWidth: 'auto',
				logoHeight: '72.4px'
			}
		];
	}
};
export interface FooterState {
	getPartners: () => FooterOptions[];
	getServices: () => FooterOptions[];
}
export const BeaconFooterState = {
	...DEFAULT_STATE
};
export interface FooterOptions extends HeaderOptions {
	text: string;
	logoUrl: string;
	logoWidth: string;
	display?: string;
	logoHeight: string;
}

export interface IHelpLinks {
	text: string;
	link: string;
	className: string;
}

export const HelpLinks: IHelpLinks[] = [
	...(import.meta.env.VITE_SHOW_ABOUT_FOOTER === 'true'
		? [
				{
					text: 'About Us',
					link: '/about',
					className: ''
				}
		  ]
		: []),
	{
		text: 'FAQs',
		link: '/beaconFAQ',
		className: ''
	},
	{
		text: 'Newtopia Now',
		link: 'https://app.newtopianow.com/event/newtopia-2026',
		className: 'newtopia'
	},
	{
		text: 'Expo West',
		link: 'https://www.expowest.com/en/home.html',
		className: 'expo-west'
	},
	{
		text: 'New Hope Network ',
		link: 'https://www.newhope.com/',
		className: ''
	},
	{
		text: 'Contact Us @ beacondiscovery@newhope.com',
		link: 'mailto:beacondiscovery@newhope.com',
		className: ''
	}
];
